import { cn } from '@forest/shared'
import { CloseButton } from '~/components/close-button'
import { Bg } from '~/components/graphics/bg'

export function Layout(props: {
  children: React.ReactNode
  className?: string
  hideBgOverlay?: boolean
}) {
  return (
    <div
      className={cn(
        'relative h-full min-h-full overflow-y-hidden bg-[#001721] text-white',
        props.className,
      )}
    >
      <div className="absolute left-0 right-0 top-0 h-[900px] overflow-x-hidden bg-top">
        <div className="absolute left-1/2 top-0 h-full -translate-x-1/2">
          {!props.hideBgOverlay && <Bg />}
        </div>
      </div>

      {props.children}

      <CloseButton className="fixed right-4 top-[calc(16px+var(--safe-area-top))]" />
    </div>
  )
}
